/*
Square Grommets

  --width <float> | inches
  --length <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Square'
const id = 'e0lswwaBy8dDi4t7J885'

export default {
  name,
  id,
  filters,
  headers,
  form
}
